import { Button, Popconfirm, Space, Switch, Table, Tag, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { BiEdit } from "react-icons/bi";
import { IoTrashOutline } from "react-icons/io5";
import { LuUndo2 } from "react-icons/lu";

function DataTable(props: any) {
  interface DataType {
    id: number;
    title: string;
    type: string;
  }
  const columns: ColumnsType<DataType> = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 50,
      render: (text, record, index) => {
        return <div className="">{index + 1}.</div>;
      },
    },
    {
      title: "title",
      dataIndex: "title",
      key: "title",
      width: 350,
      render: (text, record: any) => {
        return (
          <div
            style={{ fontSize: "10px" }}
            onClick={() => props.onEdit(record)}
          >
            {record?.title}
          </div>
        );
      },
    },
    {
      title: "type",
      dataIndex: "type",
      key: "type",
      width: 350,
      render: (text, record: any) => {
        return (
          <div
            style={{ fontSize: "10px" }}
            onClick={() => props.onEdit(record)}
          >
            {record?.type}
          </div>
        );
      },
    },
    {
      title: "Task",
      key: "action",
      width: 50,
      render: (_, record: any) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignContent: "center",
            }}
          >
            <Space size="middle" style={{ marginRight: 10 }}>
              <BiEdit
                size={20}
                color="#f5a442"
                cursor={"pointer"}
                onClick={() => props.onEdit(record)}
              />
            </Space>
            <Space size="middle" style={{ marginRight: 10 }}>
              <Tooltip
                title={`${
                  record?.is_deleted === true ? "Recover" : "Move"
                } From Trash`}
                color={"black"}
              >
                {record?.is_deleted === true ? (
                  <Popconfirm
                    title="Recover item"
                    description="Are you sure you want to recover this item from trash?"
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => props.unTrash(record)}
                  >
                    <LuUndo2 color="blue" size={20} cursor={"pointer"} />
                  </Popconfirm>
                ) : (
                  <Popconfirm
                    title="Move to trash"
                    description="Are you sure you want to move this item to trash?"
                    okText="Yes"
                    cancelText="No"
                    okButtonProps={{ danger: true }}
                    onConfirm={() => props.onTrash(record)}
                  >
                    <IoTrashOutline color="red" size={20} cursor={"pointer"} />
                  </Popconfirm>
                )}
              </Tooltip>
            </Space>
            {record?.is_deleted === true ? (
              <Popconfirm
                title="Delete permanently"
                description="This will permanently delete the item. This action cannot be undone. Continue?"
                okText="Yes"
                cancelText="No"
                okButtonProps={{ danger: true }}
                onConfirm={() => props?.onDelete(record)}
              >
                <Button size="small" danger style={{ fontSize: 12 }}>
                  Remove
                </Button>
              </Popconfirm>
            ) : null}
          </div>
        );
      },
    },
  ];
  return (
    <div>
      <Table
        columns={columns}
        dataSource={props.data}
        className="commen-table-custom-scrollbar"
        pagination={false}
        size="small"
      />
    </div>
  );
}

export default DataTable;
